// src/pages/StudentProfile.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './StudentProfile.css';

export default function StudentProfile() {
  const [loading, setLoading]     = useState(true);
  const [message, setMessage]     = useState('');
  const [profile, setProfile]     = useState({
    nombre: '',
    rut: '',
    email: '',
    curso: '',
    notaFinal: '',
    // electivos año anterior (no editables)
    previousElective1: '',
    previousElective2: '',
    previousElective3: ''
  });
  const [passwords, setPasswords] = useState({
    current: '',
    nuevo: '',
    confirm: ''
  });

  const API = process.env.REACT_APP_API_URL || '';

  // simple dictionary to map códigos → nombres
  const electivosDict = {
    'AEF-ARTVIS': 'Artes Visuales',
    'CNM-BIO':    'Biología de los ecosistemas',
    'AEF-CEFYS':  'Ciencia del ejercicio físico y deportivo',
    'LCS-ECON':   'Economía y Sociedad',
    'CNM-SALUD':  'Ciencias de la salud',
    'LCS-HIST':   'Comprensión Histórica del presente',
    'CNM-LIDER':  'Probabilidad y Estadística',
    'AEF-PROMSAL':'Promoción de estilos de vida activos y saludables',
    'CNM-FIS':    'Física',
    'LCS-GTSA':   'Geografía, territorio y desafíos socioambientales',
    'AEF-INTMUS':'Interpretación Musical',
    'LCS-LEESP':  'Taller de Literatura'
    // …añade aquí más según tu catálogo
  };

  // 1) Carga inicial de datos
  useEffect(() => {
    const token = localStorage.getItem('token');
    axios.get(`${API}/student/me`, {
      headers: { Authorization: `Bearer ${token}` }
    })
    .then(res => {
      const d = res.data;
      setProfile({
        nombre:            d.nombre    || '',
        rut:               d.rut       || '',
        email:             d.email     || '',
        curso:             d.curso     || '',
        notaFinal:         d.nota_final != null ? d.nota_final : '',
        previousElective1: d.previous_elective_1_id || '',
        previousElective2: d.previous_elective_2_id || '',
        previousElective3: d.previous_elective_3_id || ''
      });
    })
    .catch(() => setMessage('Error cargando perfil'))
    .finally(() => setLoading(false));
  }, [API]);

  // 2) Handlers genéricos
  function handleProfileChange(e) {
    const { name, value } = e.target;
    setProfile(p => ({ ...p, [name]: value }));
  }

  function handlePwdChange(e) {
    const { name, value } = e.target;
    setPasswords(p => ({ ...p, [name]: value }));
  }

  // 3) Guardar perfil (solo email)
  async function submitProfile(e) {
    e.preventDefault();
    setMessage('');
    try {
      const token = localStorage.getItem('token');
      await axios.put(
        `${API}/student/me`,
        {
          // nombre ya no es editable
          email: profile.email
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setMessage('Perfil actualizado ✔️');
    } catch {
      setMessage('Error actualizando perfil');
    }
  }

  // 4) Cambiar contraseña
  async function submitPassword(e) {
    e.preventDefault();
    if (passwords.nuevo !== passwords.confirm) {
      setMessage('Las nuevas contraseñas no coinciden');
      return;
    }
    try {
      const token = localStorage.getItem('token');
      await axios.put(
        `${API}/student/change-password`,
        {
          current: passwords.current,
          nuevo:   passwords.nuevo
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setMessage('Contraseña cambiada ✔️');
      setPasswords({ current: '', nuevo: '', confirm: '' });
    } catch (err) {
      setMessage(err.response?.data?.message || 'Error cambiando contraseña');
    }
  }

  if (loading) return <p>Cargando...</p>;

  return (
    <div className="student-profile">
      {/* Saludo de bienvenida */}
      <h2>Bienvenido, {profile.nombre}</h2>

      <h2>Mi Perfil</h2>
      {message && <div className="message">{message}</div>}

      <form onSubmit={submitProfile} className="profile-form">
        <label>Nombre</label>
        <input
          name="nombre"
          value={profile.nombre}
          disabled
        />

        <label>RUT</label>
        <input
          name="rut"
          value={profile.rut}
          disabled
        />

        <label>Email</label>
        <input
          name="email"
          type="email"
          value={profile.email}
          onChange={handleProfileChange}
        />

        <label>Curso</label>
        <input
          name="curso"
          value={profile.curso}
          disabled
        />

        <label>Nota Final</label>
        <input
          name="notaFinal"
          value={profile.notaFinal}
          disabled
        />

        <h3>Electivos Año Anterior</h3>
        <label>Electivo 1</label>
        <input
          value={electivosDict[profile.previousElective1] || profile.previousElective1}
          disabled
        />
        <label>Electivo 2</label>
        <input
          value={electivosDict[profile.previousElective2] || profile.previousElective2}
          disabled
        />
        <label>Electivo 3</label>
        <input
          value={electivosDict[profile.previousElective3] || profile.previousElective3}
          disabled
        />

        <button type="submit">Guardar Perfil</button>
      </form>

      <h3>Cambiar Contraseña</h3>
      <form onSubmit={submitPassword} className="password-form">
        <label>Contraseña Actual</label>
        <input
          type="password"
          name="current"
          value={passwords.current}
          onChange={handlePwdChange}
          required
        />

        <label>Nueva Contraseña</label>
        <input
          type="password"
          name="nuevo"
          value={passwords.nuevo}
          onChange={handlePwdChange}
          required
        />

        <label>Confirmar Nueva</label>
        <input
          type="password"
          name="confirm"
          value={passwords.confirm}
          onChange={handlePwdChange}
          required
        />

        <button type="submit">Cambiar Contraseña</button>
      </form>
    </div>
  );
}
